import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { MapsAPILoader, AgmMap } from '@agm/core';
import { Router } from '@angular/router';
import { AlertService } from '../services/alert/alert.service';

@Component({
  selector: 'app-map-view-stores',
  templateUrl: './map-view-stores.page.html',
  styleUrls: ['./map-view-stores.page.scss'],
})
export class MapViewStoresPage implements OnInit {
  latitude: number;
  longitude: number;
  zoom: number;

  public mylocations: any = [];

 storeMarker: any = {
    url: './assets/img/pin.png',
    scaledSize: {
        width: 40,
        height: 40
    }
  }

  currentLocation: any = {
    url: './assets/img/location.png',
    scaledSize: {
        width: 40,
        height: 40
    }
  }

  public customStyle = [{  
    "featureType": "poi",  
    "elementType": "all",  
    "stylers": [{  
        visibility: "off",  
    }]  
  }, ];  

  constructor(
    private mapsAPILoader: MapsAPILoader,
    public alert: AlertService) { 
      if(localStorage.getItem('near-by-stores') != undefined && localStorage.getItem('near-by-stores') != null && localStorage.getItem('near-by-stores') != '' && localStorage.getItem('near-by-stores') != 'null'){
        let temp = JSON.parse(localStorage.getItem('near-by-stores'))
        if(temp.length > 0){
          for(let i = 0; i < temp.length; i++) {
            this.mylocations.push({
              lat: temp[i].store_latitude,
              lng: temp[i].store_longitude,
              store_id: temp[i].id,
              store_name: temp[i].store_name
            })
          }
        }
      }
    }

    ngOnInit() {
      //load Places Autocomplete
      this.mapsAPILoader.load().then(() => {
        this.setCurrentLocation();
      });
    }


    // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 16;
      });
    }
  }

}
